import { baseDeeplink } from '../../../utils/constants';

// Same deep link shape the panel uses elsewhere (see pages/Dashboard/Preview).
// The ids matter beyond the download: AppsFlyer hands them to the previewer, which
// is what makes it open this store — and therefore what triggers the detection.
export const buildPreviewerAppLink = (platformId, storeId) =>
    `${baseDeeplink}&deep_link_value=${platformId}&deep_link_sub1=${storeId}`;
